import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TablePagination, TextField } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LoadingSpinner from '../ui/LoadingSpinner';
import NotificationsList from './NotificationsList';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import SavingSpinner from '../ui/SavingSpinner'
import AppBindStyles from '../../AppBindStyles';
import SearchField from '../ui/SearchField';

import MarkNotificationsViewedMutation from './MarkNotificationsViewedMutation';
import { addDays, isValid, startOfDay, subMonths } from 'date-fns';

const abEnvironment = new AbEnvironment();
const NotificationsQuery = graphql`
query NotificationsQuery($startDate: Datetime, $endDate: Datetime, $accountId: UUID, $userId: UUID, $severity: String, $notificationType: String, $notificationSubject: String, $viewed: Int, $rlimit: Int, $first: Int, $offset: Int) {
  getnotificationentriesforuser(startTs: $startDate, endTs: $endDate, accountId: $accountId, userId: $userId, severity: $severity, notificationType: $notificationType, notificationSubject: $notificationSubject, viewed: $viewed, rlimit: $rlimit, first: $first, offset: $offset) {
    totalCount
    ...NotificationsList_al
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    flex: {
      flex: 1,
    },
    selectField: {
      width: 140
    }
});

class Notifications extends Component {

    constructor(props) {
      super(props);
   
      let noteToDate = new Date();
      let tDate = localStorage.getItem('noteToDate');
      if (tDate != null) {
        noteToDate = new Date(tDate);
      }
      //query looks at 
      //search todate would be start of next day.
      let searchToDateUtc = startOfDay(addDays(noteToDate, 1)).toISOString();
  
      let noteFromDate = new Date();
      let fDate = localStorage.getItem('noteFromDate');
      if (fDate != null) {
        noteFromDate = new Date(fDate);
      } else {
        noteFromDate = subMonths(noteToDate, 1);
      }
      //search fromdate would be start of next day. 
      let searchFromDateUtc = startOfDay(noteFromDate).toISOString();
  
      let viewOption = localStorage.getItem('noteViewOpt');
      let viewOptionInt = 0;
      if (viewOption) {
          viewOptionInt = parseInt(viewOption, 10);
      }

      let severityOption = localStorage.getItem('severityOpt');
      if (! severityOption) {
        severityOption = '';
      }
 
      this.state = {
        startDate: noteFromDate,
        queryStartDateUtc: searchFromDateUtc,
        endDate: noteToDate,
        queryEndDateUtc: searchToDateUtc,
        notificationSubject: '',
        viewed: viewOptionInt,
        severity: severityOption,
        page: 0,
        rowsPerPage: 10,
        showSpinner: false,
        confirmMarkAll: false
      };  
    }

    handleChange = name => event => {
      this.setState({
        [name]: event.target.value,
        page: 0,
      });
    };

    setFromDate(theDate) {
      if (isValid(theDate)) {
        let searchFromDateUtc = startOfDay(new Date(theDate)).toISOString();
        localStorage.setItem('noteFromDate', theDate);
        this.setState({ startDate: theDate, queryStartDateUtc: searchFromDateUtc, page : 0 });
      }
    }
    
    setToDate(theDate) {
      if (isValid(theDate)) {
        let searchToDateUtc = startOfDay(addDays(new Date(theDate), 1)).toISOString()
        localStorage.setItem('noteToDate', theDate);
        this.setState({ endDate: theDate, queryEndDateUtc: searchToDateUtc, page : 0 });
      }
    }
    
    handleViewedChange = (event) => {
      localStorage.setItem('noteViewOpt', event.target.value);
      this.setState({viewed: event.target.value, page: 0})
    };

    handleSeverityChange = (event) => {
      let aSeverity = event.target.value;
      if (aSeverity === 'all') {
        aSeverity = '';
      }
      localStorage.setItem('severityOpt', aSeverity);
      this.setState({severity: aSeverity, page: 0})
    };

    handleChangePage = (event, page) => {
      this.setState({page: page});
    }
    
    handleChangeRowsPerPage = (event) => {
      this.setState({ rowsPerPage: event.target.value, page : 0});
    }

    showSpinner() {
      return this.state.showSpinner;
    }

    markAllViewed = () => {
      this.setState({ showSpinner: true });
      const accountId = abEnvironment.getUserAttribute("a_id");
      const userId = abEnvironment.getUserAttribute("u_id");
      MarkNotificationsViewedMutation.commit(accountId, userId)
      .then(response => {
        this.setState({ showSpinner: false });
        window.location.reload();
      })
      .catch(error => {
        this.setState({ showSpinner: false });
        window.location.reload();
      });
    }

    render() {
      const classes = this.props.classes;
       
      // Determine the offset
      let offset = 0;
      if (this.state.page > 0)
      {
        offset = this.state.page * this.state.rowsPerPage
      }
      let first = this.state.rowsPerPage;
    
      let totalCount = 0;

      let viewStatus = this.state.viewed;
      if (this.state.viewed === 2) {
        //2 = "show both" so here we null it out so backend function knows to ignore
        viewStatus = null;
      }

      let theSeverity = this.state.severity;
      if (theSeverity == null || theSeverity === '') {
        theSeverity = 'all';
      }

      //add % for the user so subject is treated like a wildcard
      let notificationSubject = '%' + this.state.notificationSubject + '%';

      return (
        <div className={classes.root}>
          <Grid container spacing={1} justifyContent="space-between" style={{marginTop: 24, marginBottom: 16}}>
            <Grid item>
              <Grid container spacing={2}>
                <Grid item style={AppBindStyles.datePickerField}>
                  <DatePicker
                    disableFuture
                    label="From date"
                    value={this.state.startDate}
                    onChange={(date) => this.setFromDate(date) }
                    renderInput={(params) => (
                      <TextField 
                        {...params}
                        sx={{
                          svg: {paddingRight: '2px'}
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item style={AppBindStyles.datePickerField}>
                  <DatePicker
                    disableFuture
                    label="To Date"
                    value={this.state.endDate}
                    onChange={(date) => this.setToDate(date) }
                    renderInput={(params) => (
                      <TextField 
                        {...params}
                        sx={{
                          svg: {paddingRight: '2px'}
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item>
                  <FormControl  variant="standard" className={classes.selectField}>
                    <InputLabel id="severity">Severity</InputLabel>
                    <Select
                      labelId="severity"
                      id="severity-select"
                      value={theSeverity}
                      onChange={this.handleSeverityChange}>
                      <MenuItem value={'all'}>All</MenuItem>
                      <MenuItem value={'error'}>Error</MenuItem>
                      <MenuItem value={'warning'}>Warning</MenuItem>
                      <MenuItem value={'info'}>Info</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <SearchField
                    id="notificationSubject"
                    label="Search by subject"
                    value={this.state.notificationSubject}
                    onChange={this.handleChange('notificationSubject')}
                  />

                </Grid>
                <Grid item>
                  <FormControl  variant="standard" className={classes.selectField}>
                    <InputLabel id="viewed-status">Viewed?</InputLabel>
                    <Select
                      labelid="Viewed?"
                      id="read-status-select"
                      value={this.state.viewed}
                      onChange={this.handleViewedChange}>
                      <MenuItem value={0}>Unviewed</MenuItem>
                      <MenuItem value={1}>Viewed</MenuItem>
                      <MenuItem value={2}>Both</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={NotificationsQuery}
            variables={{startDate: this.state.queryStartDateUtc,
                        endDate: this.state.queryEndDateUtc,
                        notificationSubject: notificationSubject,
                        accountId: abEnvironment.getUserAttribute("a_id"),
                        userId: abEnvironment.getUserAttribute("u_id"),
                        severity: this.state.severity,
                        viewed: viewStatus,
                        rlimit: 100,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                return <div>{error.message}</div>
              } else if (props) {
                // Determine offset information
                totalCount = props.getnotificationentriesforuser.totalCount;

                let enableMarkAllButton = false;
                if (totalCount > 0 && this.state.viewed !== 1) {
                  enableMarkAllButton = true;
                }

                return (
                  <div>
                    <NotificationsList userId={abEnvironment.getUserAttribute("u_id")} al={props.getnotificationentriesforuser}/>
                    <div style={{marginTop: '10px'}}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>

                    <div>
                      { !this.showSpinner() && enableMarkAllButton > 0 &&
                        <Button variant="contained" color="primary"  style={AppBindStyles.bottomButton} onClick={() => { this.setState({confirmMarkAll:true}); }}>
                          <VisibilityIcon style={{marginTop: -2}}/>&nbsp;&nbsp;&nbsp;Mark all viewed
                        </Button>
                      }
                      { !this.showSpinner() &&  !enableMarkAllButton > 0 &&
                        <Button disabled variant="contained" color="primary"  style={AppBindStyles.bottomButton}>
                          <VisibilityIcon  style={{marginTop: -2}} color="disabled"/>&nbsp;&nbsp;&nbsp;Mark all viewed
                        </Button>
                      }
                      {this.showSpinner() &&
                      <Button color="primary" variant="contained" >
                        <SavingSpinner/></Button>
                      }
                      <ConfirmationDialog
                          open={this.state.confirmMarkAll}
                          onClose={() => { this.setState({confirmMarkAll:false});}}
                          onConfirm={() => { this.markAllViewed(); }}
                          onCancel={() => { }}
                          title="Mark all notifications viewed?"
                          cancelBtn="Cancel"
                          okBtn="Ok"
                        >
                          If you proceed, you will still be able to view notifications by selecting the viewed option.
                      </ConfirmationDialog>  
                      </div>
                  </div>
                )
              }
              return (
                <LoadingSpinner />
              );
            }}
          />
        </div>
      );
    }
}
  
Notifications.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(Notifications);